import { render, staticRenderFns } from "./free.vue?vue&type=template&id=10aa1376"
import script from "./free.vue?vue&type=script&lang=js"
export * from "./free.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports